import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import EmailNotificationActionDetail from 'automation-ui-action-features/actions/email-notification/EmailNotificationActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class EmailNotificationActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      flowObjectTypeId,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(EmailNotificationActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
}
export default EmailNotificationActionHistoryCard;